'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var index = require('../../../../common/providers/ClaimBuilder/index.js');
var ItemSelectionPackageHeader = require('../../../../common/views/ItemSelection/ItemSelectionPackageHeader.js');
var ItemSelectionPackageItemsContainer = require('../../../../common/views/ItemSelection/ItemSelectionPackageItemsContainer.js');
var ItemSelectionSelectableCard = require('../../../../common/views/ItemSelection/ItemSelectionSelectableCard.js');
var ItemSelectionItemCardClaims = require('../../../../common/views/ItemSelection/ItemSelectionItemCardClaims.js');
var PackageName = require('../../../../common/components/PackageName.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemSelectionPackage = _ref => {
  let {
    shipment
  } = _ref;
  const {
    state: {
      itemClaims
    },
    getFullItemDetails
  } = index.useClaimBuilder();
  return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(ItemSelectionPackageHeader["default"], {
    shipment: shipment
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, /*#__PURE__*/React__default["default"].createElement(PackageName["default"], {
    edd: shipment.edd,
    status: shipment.status,
    statusCode: shipment.statusCode
  }))), /*#__PURE__*/React__default["default"].createElement(ItemSelectionPackageItemsContainer["default"], null, shipment.items.map(item => {
    const itemDetails = getFullItemDetails(item.itemRefId, shipment.id);
    const claimDetails = itemClaims[`${item.itemRefId}_${shipment.id}`];
    const isSelected = Boolean(claimDetails);
    if (!itemDetails) throw new Error('Insufficient item details');
    const {
      isEligible
    } = itemDetails.evaluatedEligibility;
    return /*#__PURE__*/React__default["default"].createElement(ItemSelectionSelectableCard["default"], {
      key: item.itemRefId,
      item: item,
      packageId: shipment.id,
      selected: isSelected,
      readOnly: isSelected || !isEligible
    }, /*#__PURE__*/React__default["default"].createElement(ItemSelectionItemCardClaims["default"], {
      item: item,
      itemDetails: itemDetails,
      packageId: shipment.id,
      key: item.itemRefId,
      disabled: !isEligible
    }));
  })));
};

exports["default"] = ItemSelectionPackage;
